import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Product } from 'src/Model/Product-Interfaces';
import { Recipe } from 'src/Model/Product-Interfaces';
import { Menu, StopOnlineOrders } from 'src/Model/WebCustomer';
import { popupService } from '../popup/popup.service';
import { ApiService } from '../service/api.service';
import { GetterService } from '../service/getter-service.service';
import { RequestService } from '../service/request.service';
import { UserService } from '../service/user.service';
import { STOPONLINEORDERS } from '../side-cart/side-cart.component';
import { InquiryPopupService } from '../store/inquiry-popup/inquiry-popup.service';
import { recomendationsService } from './recomendations.service';
import { RecomendationsSwitchService } from '../service/recomendations-switch.service';
import { PosthogService } from '../analytics/services/posthog.service';
import { PromotionItemService } from '../service/PromotionItem.service';
import { PromotionItem } from 'src/Model/PromotionItem.interface';
import { DesignService } from '../design/design.service';
import { brandFlavor, pageSegment } from 'src/app/brand/brand-context';

@Component({
  selector: 'app-recomendations',
  templateUrl: './recomendations.component.html',
  styleUrls: ['./recomendations.component.scss'],
})
export class RecomendationsComponent implements OnInit, OnDestroy {
  brandFlavour: string;
  checkOutOff: boolean;
  ShowCheckOutOffMsg: string = '';
  recommendations;
  recomendedRecipies: Array<Recipe> = [];
  recomendedRecipiesBackup: Array<Recipe> = [];

  freeRecipies: Array<Partial<Recipe>> = [];

  recomendedProducts: Array<Product> = [];
  recomendedProductsBackup: Array<Product> = [];
  SelectedButtonColor;
  SelectedButtonTextColor;
  distributorLogin: boolean;
  recomendationsButtonText: string;

  checkOutActive: boolean;
  StopOnlineDeliveryOrders: boolean;
  StopOnlineCollectionOrders: boolean;
  StopOnlineEatInOrders: boolean;
  stopOnlineOrders: StopOnlineOrders = STOPONLINEORDERS;

  subs: Subscription[] = [];
  deliveryType: string;

  promotionItemsSettings: Menu['PromotionItemsSettings'];
  newDesign = pageSegment() == 'new-menu';

  continueBtnOnTop = false;
  redirectAfterAdding: boolean = false;

  constructor(
    private _requestService: RequestService,
    private recomendationsService: recomendationsService,
    private router: Router,
    private apiService: ApiService,
    private popupService: popupService,
    private _local: GetterService,
    private inquiryService: InquiryPopupService,
    private user: UserService,
    private PromotionItemService: PromotionItemService,
    private posthog: PosthogService,
    private recomendationsSwitch: RecomendationsSwitchService,
    private design: DesignService
  ) {}

  ngOnInit(): void {
    this.brandFlavour = brandFlavor();

    const sub = this._requestService.deliveryType$.subscribe((type) => {
      this.getRecommendedRecipes();
    });

    this.subs.push(sub);

    const sub2 = this.recomendationsService.showRecomendations.subscribe(() => {
      this.posthog.captureEvent('Recomended Items Popup Opens');

      // 1. Guard Clauses: Check if checkout is active
      if (!this.checkOutActive) {
        this.posthog.captureEvent('We are not currently taking any orders');
        this.ShowCheckOutOffMsg = 'We are not currently taking any orders';
        return;
      }

      // 2. Guard Clauses: Check Delivery Type Status
      const deliveryType = this._requestService.deliveryType$.value;
      const deliveryChecks = {
        Home: {
          stop: this.StopOnlineDeliveryOrders,
          msg: this.stopOnlineOrders.Delivery?.Message,
        },
        Store: {
          stop: this.StopOnlineCollectionOrders,
          msg: this.stopOnlineOrders.Collection?.Message,
        },
        EatIn: {
          stop: this.StopOnlineEatInOrders,
          msg: this.stopOnlineOrders.EatIn?.Message,
        },
      };

      const currentStatus = deliveryChecks[deliveryType];
      if (currentStatus?.stop) {
        this.ShowCheckOutOffMsg = currentStatus.msg;
        return;
      }

      // 3. Auth Check
      const isStorePath = pageSegment() === 'store';
      if (isStorePath && !this._local.get('access_token')) {
        this.inquiryService.showPopup();
        return;
      }

      // 4. Filtering Logic (Optimized with Sets)
      const cartRecipes = JSON.parse(this._local.get('cartRecipeItems')) || [];
      const cartProducts =
        JSON.parse(this._local.get('cartProductItems')) || [];

      // Create Sets of IDs for O(1) lookup time instead of nested loops
      const cartRecipeIds = new Set(cartRecipes.map((r) => r.RecipeId));
      const cartRecipeTitles = new Set(cartRecipes.map((r) => r.RecipeTitle));
      const cartProductIds = new Set(cartProducts.map((p) => p.ProductId));
      const cartProductTitles = new Set(
        cartProducts.map((p) => p.ProductTitle)
      );

      // Filter recommendations: Keep only items NOT in the cart
      this.recomendedRecipies = this.recomendedRecipiesBackup.filter(
        (r) =>
          r &&
          !cartRecipeIds.has(r.RecipeId) &&
          !cartRecipeTitles.has(r.RecipeTitle)
      );

      // Filter recommendations: Keep only items NOT in the cart
      this.recomendedProducts = this.recomendedProductsBackup.filter(
        (p) =>
          p &&
          !cartProductIds.has(p.ProductId) &&
          !cartProductTitles.has(p.ProductTitle)
      );

      // 5. Final Navigation Logic
      // (once per visit when opened from the cart drawer — see
      // RecomendationsSwitchService.skipThisTime)
      const hasSomething =
        this.recomendedRecipies.length ||
        this.recomendedProducts.length ||
        (this.freeRecipies.length && this.promotionItemsSettings?.Enabled);

      if (hasSomething && !this.recomendationsSwitch.skipThisTime()) {
        this.recommendations = true;
        this.recomendationsSwitch.markSeen();
      } else {
        if (hasSomething) {
          this.posthog.captureEvent('recommendations_skipped_seen_this_visit');
        }
        this.openUrl('checkout');
      }
    });

    this.subs.push(sub2);

    const sub3 = this.popupService.addedToCartSuccessful.subscribe((data) => {
      if (this.recommendations) {
        if (
          (this.recomendedRecipies.length == 1 ||
            this.recomendedProducts.length == 1) &&
          !this.freeRecipies.length
        ) {
          this.openUrl('checkout');
          return;
        }

        if (this.redirectAfterAdding) {
          this.openUrl('checkout');
          return;
        }

        if (this.recomendedRecipies.length) {
          this.recomendedRecipies.forEach((recipe, index) => {
            if (recipe.RecipeId == data.RecipeId) {
              this.recomendedRecipies.splice(index, 1);
            }
          });
        } else {
          this.recomendedProducts.forEach((product, index) => {
            if (product.ProductId == data.ProductId) {
              this.recomendedProducts.splice(index, 1);
            }
          });
        }
      }
    });
    this.subs.push(sub3);

    const sub4 = this.PromotionItemService.promotionsItems$.subscribe(
      (data) => {
        this.freeRecipies = data
          .map((item) => ({ ...item.RecipeDetails }))
          .filter((r) => !r.isLocked);
      }
    );

    this.subs.push(sub4);

    this.getWebCustomer();
  }

  getWebCustomer() {
    const sub = this.apiService.getWebcustomer$.subscribe((res) => {
      if (!res) {
        return;
      }
      this.continueBtnOnTop =
        res.TemplateData.Recommendations?.ContinueBtnOnTop ?? false;

      this.redirectAfterAdding =
        res.TemplateData.Recommendations?.RedirectAfterAdding ?? false;

      this.continueBtnOnTop =
        res.TemplateData.Recommendations?.ContinueBtnOnTop ?? false;

      this.redirectAfterAdding =
        res.TemplateData.Recommendations?.RedirectAfterAdding ?? false;

      this.newDesign = !!res.TemplateData?.HomeTemplate?.Campaigns?.find(
        (t) => t.Redirection == 'new-menu'
      );

      this.promotionItemsSettings =
        res.TemplateData?.Menu?.PromotionItemsSettings;

      this.recomendationsButtonText =
        res.TemplateData.CheckoutButtonsText?.RecomendationsButtonText;
      this.SelectedButtonColor =
        res.TemplateData.DynamicStyle.SecondaryColors.SelectedButtonColor;
      this.SelectedButtonTextColor =
        res.TemplateData.DynamicStyle.SecondaryColors.SelectedButtonTextColor;

      this.checkOutActive = res.TemplateData.CheckoutDetail.Active;

      if (typeof res.TemplateData.CheckoutDetail?.Active == 'undefined') {
        this.checkOutActive = true;
      }

      if (res.TemplateData.CartMessage?.StopOnlineOrders)
        this.stopOnlineOrders = res.TemplateData.CartMessage?.StopOnlineOrders;

      this.getConfig();
    });

    this.subs.push(sub);
  }

  getConfig() {
    const sub = this.apiService.getbrandConfig$.subscribe((res) => {
      if (!res) return;
      this.checkOutOff = res.Active;
      this.StopOnlineDeliveryOrders = res.StopOnlineDeliveryOrders;
      this.StopOnlineCollectionOrders = res.StopOnlineCollectionOrders;
      this.StopOnlineEatInOrders = res.StopOnlineEatInOrders;
    });

    this.subs.push(sub);
  }

  ngOnDestroy() {
    this.subs.forEach((s) => s.unsubscribe());
  }

  getRecommendedRecipes() {
    let url = 'api/Recipe/RecommendedItems/' + this.brandFlavour;

    if (this._requestService.deliveryType$.value) {
      let type = this._requestService.deliveryType$.value;
      url =
        url +
        '/' +
        (type == 'Home'
          ? 'Delivery'
          : type == 'Store'
            ? 'Pickup'
            : type == 'EatIn'
              ? 'EatIn'
              : '');
    }
    this._requestService.getRequest(url).subscribe((res) => {
      if (res['Info'].Status == 200) {
        this.recomendedRecipies = res['RecipesData'];
        this.recomendedProducts = res['ProductsData'];

        this.recomendedRecipiesBackup = [...this.recomendedRecipies];
        this.recomendedProductsBackup = [...this.recomendedProducts];
      }
    });
  }

  openUrl(url: string) {
    const component = pageSegment();

    // simpleCheckout → order-checkout (not from the store page), then
    // distributor → legacy checkout, else new / legacy by TemplateData.NewDesign
    if (url == 'checkout') {
      url = this.design.checkoutPage({
        simpleCheckout: component !== 'store',
        simpleBeforeDistributor: true,
      });
    }
    const recipes = this._requestService.getCartRecipeItems();
    let total = 0;
    let quantity = 0;
    recipes.forEach((recipe) => {
      total += recipe.TotalPrice;
      quantity += recipe.Quantity;
    });

    this.posthog.captureEvent('checkout_initiated', {
      cartTotal: total,
      recipeItemsCount: quantity,
      source: 'recommended_items_popup',
    });

    this.posthog.captureEvent('Open Checkout from Recomended Items Popup');

    if (component == 'training') {
      url = 'checkout?training=true';
    }

    this.posthog.captureEvent('Open Checkout from Recomended Items Popup', {
      url: url,
    });

    this.router.navigateByUrl(this._requestService.setUrl(url));
    this.recommendations = false;
    this.recomendedRecipies = [];
    this.recomendedProducts = [];
    this.recomendedRecipies = [...this.recomendedRecipiesBackup];
    this.recomendedProducts = [...this.recomendedProductsBackup];
  }
}
